import React from "react";
import { withRouter } from "react-router-dom";
import { PageSettings } from "./../config/page-settings.js";
import { Api } from "./../app-controller.js";

class PasswordReset extends React.Component {
  static contextType = PageSettings;

  state = {
    email: "",
    working: false,
    emailSended: false,
    tagMessage: "Ingrese el correo electrónico previamente registrado",
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetPageContentFullWidth(true); 
    this.context.handleSetBodyWhiteBg(false);
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ working: true, tagMessage: "Enviando su solicitud" });

    Api.xhr("public/passwordReset", { email: this.state.email }, (r) => {
      if (r) {
        if (r.msg === "Solicitud enviada") {
          this.setState({
            working: false,
            emailSended: true,
            tagMessage: "Hemos enviado un correo a " + this.state.email,
          });
        } else {
          this.setState({
            working: false,
            emailSended: false,
            tagMessage: "Error: Intente de nuevo.",
          });
        }
      }
    });
  }

  render() {
    return (
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              {/* <span className="logo " ></span>  */}
              <img
                className="logo"
                alt="Logo"
                style={{ width: "25%", height: "25%" }}
                src="../favicon.ico"
              ></img>
              <b>SINAIP</b>
            </div>
            <div className="icon">
              <i className="fa fa-envelope"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content padding-10">
              <div
                className={
                  this.state.emailSended
                    ? "note note-primary note-with-right-icon"
                    : "note note-atention note-with-right-icon"
                }
              >
                <div className="note-icon">
                  <i className="fa fa-user"></i>
                </div>
                <div className="note-content text-right">
                  {this.state.tagMessage}
                </div>
              </div>
              <form
                className={this.state.emailSended ? "hide" : "margin-bottom-0"}
                id="frmLogin"
                onSubmit={this.handleSubmit}
              >
                <div className="form-group m-b-15">
                  <input
                    type="email"
                    name="email"
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                    className="form-control form-control-lg"
                    placeholder="Correo electrónico"
                    required
                  />
                </div>

                <div className="login-buttons">
                  <button
                    type="submit"
                    className={
                      this.state.working
                        ? "btn btn-block btn-lg btn-working"
                        : "btn btn-success btn-block btn-lg"
                    }
                  >
                    {this.state.working
                      ? "Por favor espere..."
                      : "Solicitar contraseña"}
                  </button>
                </div>
              </form>
              <a href="/">
                <button className="btn btn-block btn-lg btn-danger m-t-10 ">
                  Regresar
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PasswordReset);
